"use client";

import { create } from "zustand";

interface AuthDialogStore {
  isAuthDialogOpen: boolean;
  toggleAuthDialog: (isOpen: boolean) => void;
}

/**
 * Auth dialog store
 * Manages auth dialog state
 */
export const useAuthDialogStore = create<AuthDialogStore>((set) => ({
  isAuthDialogOpen: false,
  toggleAuthDialog: (isOpen: boolean) => {
    set({ isAuthDialogOpen: isOpen });
  },
}));
